import { useContext } from 'react';
import { AuthContext } from '../components/contexts/AuthContext';

/**
 * Hook personalizado para gestionar permisos de usuario
 * Centraliza la lógica de autorización Admin/Cliente
 */
export const useUserPermissions = () => {
  const { user } = useContext(AuthContext);
  
  const isAdmin = user?.tipo === 'Admin';
  const isCliente = user?.tipo === 'Cliente';
  
  return {
    // Tipo de usuario
    userType: user?.tipo,
    isAdmin,
    isCliente,
    
    // Permisos generales
    canViewAllUsers: isAdmin,
    canEditConfig: isAdmin,
    canManageUsers: isAdmin && user?.menu_usuarios,
    canAccessAdminPanel: isAdmin && user?.menu_admin,
    
    // Permisos de bots
    canAccessDashboard: user?.dashboard || false,
    canAccessGrid: user?.dashboard || false,
    canAccessSniper: user?.dashboard || false,
    canAccessFutures: user?.dashboard || false,
    
    // Información del usuario
    currentUserId: user?._id,
    userName: user?.nombre,
    userEmail: user?.email,
    
    // Utilidades
    hasPermission: (permission) => {
      if (!user) return false;
      if (isAdmin) return true; // Admin tiene todos los permisos
      return user[permission] || false;
    },
    
    // Validar acceso a recurso de otro usuario
    canAccessUserData: (targetUserId) => {
      if (isAdmin) return true;
      return user?._id === targetUserId;
    }
  };
};

export default useUserPermissions;
